import React from 'react';

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="container">
        <div className="about-hero">
          <h1>About Bunny Boba</h1>
          <p className="hero-subtitle">
            Bringing you the finest boba tea experience with premium ingredients and authentic flavors
          </p>
        </div>

        <section className="about-content">
          <div className="content-grid">
            <div className="content-section">
              <h2>Our Story</h2>
              <p>
                Born from a passion for authentic Asian flavors and premium quality ingredients, 
                Bunny Boba started as a dream to bring the finest boba tea experience to our community. 
                We believe that every cup should be a perfect blend of tradition and innovation.
              </p>
              <p>
                Our journey began with a simple mission: to craft beverages that not only taste amazing 
                but also bring people together. From our carefully selected tea leaves to our fresh daily-made 
                pearls, every element is chosen with love and attention to detail.
              </p>
            </div>

            <div className="content-section">
              <h2>Our Mission</h2>
              <p>
                To serve the highest quality boba tea using premium ingredients while creating 
                a welcoming space for our community to connect and enjoy life's simple pleasures.
              </p>
              <div className="mission-points">
                <div className="mission-point">
                  <span className="icon">🌟</span>
                  <div>
                    <h4>Quality First</h4>
                    <p>Premium ingredients sourced responsibly</p>
                  </div>
                </div>
                {/* <div className="mission-point">
                  <span className="icon">🧋</span>
                  <div>
                    <h4>Fresh Daily</h4>
                    <p>Pearls and toppings made fresh every day</p>
                  </div>
                </div> */}
                <div className="mission-point">
                  <span className="icon">❤️</span>
                  <div>
                    <h4>Community Love</h4>
                    <p>Building connections one cup at a time</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="values-section">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🌱</div>
              <h3>Sustainability</h3>
              <p>We're committed to eco-friendly practices and sustainable sourcing</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Community</h3>
              <p>Supporting local initiatives and bringing people together</p>
            </div>
            <div className="value-card">
              <div className="value-icon">✨</div>
              <h3>Innovation</h3>
              <p>Constantly exploring new flavors while respecting tradition</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🎯</div>
              <h3>Excellence</h3>
              <p>Striving for perfection in every cup we serve</p>
            </div>
          </div>
        </section>

        <section className="location-section">
          <h2>Visit Us</h2>
          <div className="location-info">
            <div className="location-details">
              <h3>📍 Town Central Mall, LGB-08, Block B, Near Ek Murti Chowk, Greater Noida West, Uttar Pradesh</h3>
              <p><strong>Hours:</strong> 11:00 AM - 10:00 PM (7 days a week)</p>
              {/* <p><strong>What to Expect:</strong></p>
              <ul>
                <li>Cozy, Instagram-worthy interior design</li>
                <li>30+ unique boba tea flavors</li>
                <li>Fresh toppings made daily</li>
                <li>Comfortable seating for groups and individuals</li>
                <li>Free WiFi for students and remote workers</li>
              </ul> */}
            </div>
          </div>
        </section>
      </div>

      <style jsx>{`
        .about-page {
          min-height: 100vh;
          background-color: #fff8f0;
          padding: 40px 0 80px;
        }
        
        .about-hero {
          text-align: center;
          padding: 60px 20px;
          background: linear-gradient(135deg, #fcf0ff, #fff1f2);
          border-radius: 20px;
          margin-bottom: 60px;
        }
        
        .about-hero h1 {
          font-size: 3rem;
          color: #C2185B;
          margin-bottom: 20px;
          font-weight: bold;
        }
        
        .hero-subtitle {
          font-size: 1.2rem;
          color: #666;
          max-width: 600px;
          margin: 0 auto;
        }
        
        .about-content {
          margin-bottom: 80px;
        }
        
        .content-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: start;
        }
        
        .content-section h2 {
          color: #C2185B;
          font-size: 2rem;
          margin-bottom: 20px;
        }
        
        .content-section p {
          color: #666;
          line-height: 1.7;
          margin-bottom: 20px;
          font-size: 1.05rem;
        }
        
        .mission-points {
          margin-top: 30px;
        }
        
        .mission-point {
          display: flex;
          align-items: flex-start;
          gap: 15px;
          margin-bottom: 20px;
        }
        
        .mission-point .icon {
          font-size: 1.5rem;
          flex-shrink: 0;
        }
        
        .mission-point h4 {
          color: #C2185B;
          margin-bottom: 5px;
        }
        
        .mission-point p {
          color: #666;
          margin: 0;
          font-size: 0.95rem;
        }
        
        .values-section {
          margin-bottom: 80px;
        }
        
        .values-section h2 {
          text-align: center;
          color: #C2185B;
          font-size: 2.5rem;
          margin-bottom: 50px;
        }
        
        .values-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 30px;
        }
        
        .value-card {
          background-color: white;
          padding: 30px 25px;
          border-radius: 15px;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }
        
        .value-card:hover {
          transform: translateY(-5px);
        }
        
        .value-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }
        
        .value-card h3 {
          color: #C2185B;
          font-size: 1.3rem;
          margin-bottom: 15px;
        }
        
        .value-card p {
          color: #666;
          line-height: 1.6;
        }
        
        .location-section {
          background-color: white;
          padding: 50px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }
        
        .location-section h2 {
          text-align: center;
          color: #C2185B;
          font-size: 2.5rem;
          margin-bottom: 40px;
        }
        
        .location-details h3 {
          color: #C2185B;
          font-size: 1.5rem;
          margin-bottom: 20px;
        }
        
        .location-details p {
          color: #666;
          margin-bottom: 15px;
          font-size: 1.05rem;
        }
        
        .location-details ul {
          margin-top: 15px;
          padding-left: 20px;
        }
        
        .location-details li {
          color: #666;
          margin-bottom: 8px;
          line-height: 1.5;
        }
        
        @media (max-width: 768px) {
          .about-hero h1 {
            font-size: 2.2rem;
          }
          
          .content-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          
          .values-grid {
            grid-template-columns: 1fr;
          }
          
          .location-section {
            padding: 30px 25px;
          }
          
          .values-section h2,
          .location-section h2 {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutPage; 